/** Catálogos SAT mínimos — Uso de CFDI y Forma de pago (solicitud comercial). */

export const DEFAULT_INVOICE_CFDI_USE = "G03";
export const DEFAULT_INVOICE_PAYMENT_METHOD = "03";

export const CFDI_USE_OPTIONS = [
  { code: "G01", label: "G01 — Adquisición de mercancías" },
  { code: "G02", label: "G02 — Devoluciones, descuentos o bonificaciones" },
  { code: "G03", label: "G03 — Gastos en general" },
  { code: "I01", label: "I01 — Construcciones" },
  { code: "I02", label: "I02 — Mobiliario y equipo de oficina por inversiones" },
  { code: "I03", label: "I03 — Equipo de transporte" },
  { code: "I04", label: "I04 — Equipo de cómputo y accesorios" },
  { code: "I05", label: "I05 — Dados, troqueles, moldes, matrices y herramental" },
  { code: "I06", label: "I06 — Comunicaciones telefónicas" },
  { code: "I07", label: "I07 — Comunicaciones satelitales" },
  { code: "I08", label: "I08 — Otra maquinaria y equipo" },
  { code: "D01", label: "D01 — Honorarios médicos, dentales y gastos hospitalarios" },
  { code: "D02", label: "D02 — Gastos médicos por incapacidad o discapacidad" },
  { code: "D03", label: "D03 — Gastos funerales" },
  { code: "D04", label: "D04 — Donativos" },
  { code: "D05", label: "D05 — Intereses reales efectivamente pagados por créditos hipotecarios" },
  { code: "D06", label: "D06 — Aportaciones voluntarias al SAR" },
  { code: "D07", label: "D07 — Primas por seguros de gastos médicos" },
  { code: "D08", label: "D08 — Gastos de transportación escolar obligatoria" },
  { code: "D09", label: "D09 — Depósitos en cuentas para el ahorro" },
  { code: "D10", label: "D10 — Pagos por servicios educativos" },
  { code: "S01", label: "S01 — Sin efectos fiscales" },
  { code: "CP01", label: "CP01 — Pagos" },
  { code: "CN01", label: "CN01 — Nómina" },
];

export const PAYMENT_METHOD_OPTIONS = [
  { code: "01", label: "01 — Efectivo" },
  { code: "02", label: "02 — Cheque nominativo" },
  { code: "03", label: "03 — Transferencia electrónica de fondos" },
  { code: "04", label: "04 — Tarjeta de crédito" },
  { code: "05", label: "05 — Monedero electrónico" },
  { code: "06", label: "06 — Dinero electrónico" },
  { code: "08", label: "08 — Vales de despensa" },
  { code: "12", label: "12 — Dación en pago" },
  { code: "13", label: "13 — Pago por subrogación" },
  { code: "14", label: "14 — Pago por consignación" },
  { code: "15", label: "15 — Condonación" },
  { code: "17", label: "17 — Compensación" },
  { code: "23", label: "23 — Novación" },
  { code: "24", label: "24 — Confusión" },
  { code: "25", label: "25 — Remisión de deuda" },
  { code: "26", label: "26 — Prescripción o caducidad" },
  { code: "27", label: "27 — A satisfacción del acreedor" },
  { code: "28", label: "28 — Tarjeta de débito" },
  { code: "29", label: "29 — Tarjeta de servicios" },
  { code: "30", label: "30 — Aplicación de anticipos" },
  { code: "31", label: "31 — Intermediario pagos" },
  { code: "99", label: "99 — Por definir" },
];

const CFDI_USE_LABELS = Object.fromEntries(
  CFDI_USE_OPTIONS.map((o) => [o.code, o.label.replace(`${o.code} — `, "")]),
);

const PAYMENT_LABELS = Object.fromEntries(
  PAYMENT_METHOD_OPTIONS.map((o) => [o.code, o.label.replace(`${o.code} — `, "")]),
);

export function cfdiUseSelectLabel(code) {
  const c = String(code || "").trim().toUpperCase();
  if (!c) return "No especificado";
  const short = CFDI_USE_LABELS[c];
  return short ? `${c} — ${short}` : c;
}

export function paymentMethodSelectLabel(code) {
  const raw = String(code || "").trim();
  if (!raw) return "No especificado";
  const c = raw.length === 1 ? `0${raw}` : raw;
  const short = PAYMENT_LABELS[c];
  return short ? `${c} — ${short}` : c;
}

export function invoiceCfdiUseLabelForPayload(code) {
  return cfdiUseSelectLabel(code);
}

export function invoicePaymentMethodLabelForPayload(code) {
  return paymentMethodSelectLabel(code);
}
